export default {
  bind(el, binding, vnode) {
    // var el = el1.offsetParent.offsetParent;
        //弹框可拉伸最小宽高
        let minWidth = 400;

        let minHeight = 300;

        //初始非全屏

        let isFullScreen = false;

        //当前宽高

        let nowWidth = 0;

        let nowHight = 0;

        //当前顶部高度

        let nowMarginTop = 0;

        //获取弹框头部（这部分可双击全屏）

        const dialogHeaderEl = el.querySelector('.el-dialog__header');

        //弹窗

        const dragDom = el.querySelector('.el-dialog');

        // 全屏按钮（避免重复插入）
        if (!dialogHeaderEl.querySelector('.bigbtn')) {
            dialogHeaderEl.insertAdjacentHTML('beforeEnd', '<div class="bigbtn"><div class="changeBig"></div><div class="changeSmall"></div></div>');
        }
        // 缩小按钮
        if (!dialogHeaderEl.querySelector('.dialog-mini-btn')) {
            dialogHeaderEl.insertAdjacentHTML('beforeEnd', '<div class="dialog-mini-btn" title="缩小"></div>');
        }

        const bigBtn = dialogHeaderEl.querySelector('.bigbtn');
        const changeBig = dialogHeaderEl.querySelector('.changeBig');
        const changeSmall = dialogHeaderEl.querySelector('.changeSmall');
        const miniBtn = dialogHeaderEl.querySelector('.dialog-mini-btn');

        //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
        dragDom.style.overflow = "auto";

        //清除选择头部文字效果
        //dialogHeaderEl.onselectstart = new Function("return false");

        //头部加上可拖动cursor
        dialogHeaderEl.style.cursor = 'move';

        let isMinimized = false;
        let miniCache = null;

        const getMiniTopOffset = () => {
            const list = document.querySelectorAll('.el-dialog.is-minimized');
            let count = 0;
            list.forEach((item) => {
                if (item !== dragDom) count++;
            });
            return count * 46;
        };

        const minimizeDialog = () => {
            if (isMinimized || isFullScreen) return;
            const rect = dragDom.getBoundingClientRect();
            const bodyEl = dragDom.querySelector('.el-dialog__body');
            const footerEl = dragDom.querySelector('.el-dialog__footer');
            const resizeHandle = dragDom.querySelector('.dialog-resize-handle');
            miniCache = {
                width: dragDom.style.width || `${rect.width}px`,
                height: dragDom.style.height || `${rect.height}px`,
                left: dragDom.style.left || `${rect.left}px`,
                top: dragDom.style.top || `${rect.top}px`,
                marginTop: dragDom.style.marginTop,
                overflow: dragDom.style.overflow,
                bodyDisplay: bodyEl ? bodyEl.style.display : '',
                footerDisplay: footerEl ? footerEl.style.display : '',
                resizeDisplay: resizeHandle ? resizeHandle.style.display : '',
            };

            const screenWidth = document.documentElement.clientWidth;
            const screenHeight = document.documentElement.clientHeight;
            const miniWidth = 220;
            const miniHeight = 40;
            const offset = getMiniTopOffset();

            dragDom.style.position = 'absolute';
            dragDom.style.marginTop = '0';
            dragDom.style.marginBottom = '0';
            dragDom.style.width = `${miniWidth}px`;
            dragDom.style.height = `${miniHeight}px`;
            dragDom.style.left = `${screenWidth - miniWidth - 12}px`;
            dragDom.style.top = `${screenHeight - miniHeight - 12 - offset}px`;
            dragDom.style.overflow = 'hidden';
            dragDom.classList.add('is-minimized');
            el.classList.add('is-dialog-minimized');

            if (bodyEl) bodyEl.style.display = 'none';
            if (footerEl) footerEl.style.display = 'none';
            if (resizeHandle) resizeHandle.style.display = 'none';

            miniBtn.classList.add('is-restore');
            miniBtn.title = '还原';
            isMinimized = true;
        };

        const restoreDialog = () => {
            if (!isMinimized || !miniCache) return;
            const bodyEl = dragDom.querySelector('.el-dialog__body');
            const footerEl = dragDom.querySelector('.el-dialog__footer');
            const resizeHandle = dragDom.querySelector('.dialog-resize-handle');

            dragDom.style.width = miniCache.width;
            dragDom.style.height = miniCache.height;
            dragDom.style.left = miniCache.left;
            dragDom.style.top = miniCache.top;
            dragDom.style.marginTop = miniCache.marginTop;
            dragDom.style.overflow = miniCache.overflow || 'auto';
            dragDom.classList.remove('is-minimized');
            el.classList.remove('is-dialog-minimized');

            if (bodyEl) bodyEl.style.display = miniCache.bodyDisplay;
            if (footerEl) footerEl.style.display = miniCache.footerDisplay;
            if (resizeHandle) resizeHandle.style.display = miniCache.resizeDisplay;

            miniBtn.classList.remove('is-restore');
            miniBtn.title = '缩小';
            isMinimized = false;
            miniCache = null;
        };

        miniBtn.onclick = (e) => {
            e.stopPropagation();
            if (isMinimized) {
                restoreDialog();
            } else {
                minimizeDialog();
            }
        };

        let moveDown = (e) => {
            // 缩小状态下仍可拖动小条
            if (e.target && e.target.closest && e.target.closest('.dialog-mini-btn')) {
                return;
            }
            // 用实际可视位置计算，避免 margin/居中导致贴边不准
            const rect = dragDom.getBoundingClientRect();
            const disX = e.clientX - rect.left;
            const disY = e.clientY - rect.top;

            // 先落到当前可视坐标，再改绝对定位，避免一按下就跳到左上角
            dragDom.style.left = `${rect.left}px`;
            dragDom.style.top = `${rect.top}px`;
            dragDom.style.marginTop = '0';
            dragDom.style.marginBottom = '0';
            dragDom.style.position = 'absolute';

            document.onmousemove = function (e) {
                let left = e.clientX - disX;
                let top = e.clientY - disY;

                const dragDomWidth = dragDom.offsetWidth;
                const dragDomHeight = dragDom.offsetHeight;
                const screenWidth = document.documentElement.clientWidth;
                const screenHeight = document.documentElement.clientHeight;

                // 可贴齐四边，但不能拖出屏幕
                left = Math.min(Math.max(left, 0), Math.max(0, screenWidth - dragDomWidth));
                top = Math.min(Math.max(top, 0), Math.max(0, screenHeight - dragDomHeight));

                dragDom.style.left = `${left}px`;
                dragDom.style.top = `${top}px`;
            };

            document.onmouseup = function () {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }

        dialogHeaderEl.onmousedown = moveDown;

        //双击头部全屏效果

        bigBtn.onclick = (e) => {
            if (isMinimized) return;
            if (isFullScreen == false) {

                changeBig.style.display = 'none';

                changeSmall.style.display = 'block';

                nowHight = dragDom.clientHeight;

                nowWidth = dragDom.clientWidth;

                nowMarginTop = dragDom.style.marginTop;

                dragDom.style.left = 0;

                dragDom.style.top = 0;

                dragDom.style.height = "100VH";

                dragDom.style.width = "100VW";

                dragDom.style.marginTop = 0;

                isFullScreen = true;

                dialogHeaderEl.style.cursor = 'initial';

                dialogHeaderEl.onmousedown = null;

            } else {

                changeBig.style.display = 'block';

                changeSmall.style.display = 'none';

                dragDom.style.height = "auto";

                dragDom.style.width = nowWidth + 'px';

                dragDom.style.marginTop = nowMarginTop;

                isFullScreen = false;

                dialogHeaderEl.style.cursor = 'move';

                dialogHeaderEl.onmousedown = moveDown;

            }

        }

        dragDom.onmousemove = function (e) {
            // console.log(dialogHeaderEl,dragDom.querySelector('.el-dialog__body'), 123);
            let moveE = e;

            if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {

                dragDom.style.cursor = 'w-resize';

            } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {

                dragDom.style.cursor = 's-resize';

            } else {

                dragDom.style.cursor = 'default';

                dragDom.onmousedown = null;

            }

            dragDom.onmousedown = (e) => {

                const clientX = e.clientX;

                const clientY = e.clientY;

                let elW = dragDom.clientWidth;

                let elH = dragDom.clientHeight;

                let EloffsetLeft = dragDom.offsetLeft;

                let EloffsetTop = dragDom.offsetTop;

                dragDom.style.userSelect = 'none';

                let ELscrollTop = el.scrollTop;

                //判断点击的位置是不是为头部

                if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {

                    //如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;

                } else {

                    document.onmousemove = function (e) {

                        e.preventDefault(); // 移动时禁用默认事件

                        //左侧鼠标拖拽位置

                        if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {

                            //往左拖拽

                            if (clientX > e.clientX) {

                                dragDom.style.width = elW + (clientX - e.clientX) * 2 + 'px';

                            }

                            //往右拖拽

                            if (clientX < e.clientX) {

                                if (dragDom.clientWidth < minWidth) {

                                } else {

                                    dragDom.style.width = elW - (e.clientX - clientX) * 2 + 'px';

                                }

                            }

                        }

                        //右侧鼠标拖拽位置

                        if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {

                            //往左拖拽

                            if (clientX > e.clientX) {

                                if (dragDom.clientWidth < minWidth) {

                                } else {

                                    dragDom.style.width = elW - (clientX - e.clientX) * 2 + 'px';

                                }

                            }

                            //往右拖拽

                            if (clientX < e.clientX) {

                                dragDom.style.width = elW + (e.clientX - clientX) * 2 + 'px';

                            }

                        }

                        //底部鼠标拖拽位置

                        if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {

                            //往上拖拽

                            if (clientY > e.clientY) {

                                if (dragDom.clientHeight < minHeight) {

                                } else {

                                    dragDom.style.height = elH - (clientY - e.clientY) * 2 + 'px';

                                }

                            }

                            //往下拖拽

                            if (clientY < e.clientY) {

                                dragDom.style.height = elH + (e.clientY - clientY) * 2 + 'px';

                            }

                        }

                    };

                    //拉伸结束

                    document.onmouseup = function (e) {

                        document.onmousemove = null;

                        document.onmouseup = null;

                    };

                }

            }

        }
  }
};